// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import firebase from "firebase/compat/app";
// import "firebase/compat/auth";
// import "firebase/compat/firestore";


// const firebaseConfig = {
//   apiKey: "AIzaSyDQwM0b-gAQUZjLMGbwh89kIef4mXuFw_E",
//   authDomain: "twitter-clone-57284.firebaseapp.com",
//   projectId: "twitter-clone-57284",
//   storageBucket: "twitter-clone-57284.appspot.com",
//   messagingSenderId: "49493156153",
//   appId: "1:49493156153:web:39505cd25ffb00b6e388e8"
// };


// const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);
// const auth = firebase.auth();
// export default db;

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDQwM0b-gAQUZjLMGbwh89kIef4mXuFw_E",
    authDomain: "twitter-clone-57284.firebaseapp.com",
    projectId: "twitter-clone-57284",
    storageBucket: "twitter-clone-57284.appspot.com",
    messagingSenderId: "49493156153",
    appId: "1:49493156153:web:39505cd25ffb00b6e388e8"
});

const db = firebaseApp.firestore();

const auth = firebase.auth();
export { db as default, auth };
